(function(){
  function initBoard(root){
    if(!root||root.dataset.hdbInit) return; root.dataset.hdbInit='1';
    var dataEl=root.querySelector('[data-hdb-data]'); var DATA;
    try{DATA=JSON.parse(dataEl.textContent);}catch(e){return;}
    var TOWNS=DATA.towns, COLS=DATA.cols;
    var RNAME={'3':'3-Room','4':'4-Room','5':'5-Room','E':'Executive'}, ROOMS=['3','4','5','E'];
    var cfg={room:root.dataset.defaultRoom||'4',auto:root.dataset.auto==='true',
      baseInterval:parseInt(root.dataset.interval||'4200',10),speedFactor:1,
      durMs:parseInt(root.dataset.durMs||'360',10),
      stag:parseInt(root.dataset.stagMs||'55',10)};
    Object.defineProperty(cfg,'interval',{get:function(){return Math.round(cfg.baseInterval*cfg.speedFactor);}});
    root.style.setProperty('--flap-dur',(cfg.durMs/1000)+'s');
    var grid=root.querySelector('[data-board-grid]'), title=root.querySelector('[data-flap-title]'), timer=null;
    function fmt(v){return v?'$'+Math.round(v/1000)+'K':'—';}
    function tiles(str){return str.split('').map(function(ch){
      if(ch==='$')return '<span class="pfx">$</span>';
      if(/[0-9A-Za-z]/.test(ch))return '<span class="fc">'+ch+'</span>';
      return '<span class="fc sep">'+ch+'</span>';}).join('');}
    function build(){
      var cols={}; Object.keys(COLS).forEach(function(k){cols[k]=[];});
      TOWNS.forEach(function(t){(cols[t.col]=cols[t.col]||[]).push(t);});
      grid.innerHTML=Object.keys(COLS).map(function(k){
        var rows=(cols[k]||[]).map(function(t,i){
          var c=t.m[cfg.room]||[0,0],v=c[0],d=c[1],cc=d>0?'up':(d<0?'dn':'fl'),ca=d>0?'▲':(d<0?'▼':'·');
          return '<div class="brow" data-town="'+t.name+'"><span class="idx">'+String(i+1).padStart(2,'0')+'</span><span class="twn">'+t.name+'</span><span class="lead"></span><span class="flap">'+tiles(fmt(v))+'</span><span class="chg '+cc+'">'+(v?ca+' '+(d>0?'+':'')+d.toFixed(1):'&nbsp;')+'</span></div>';
        }).join('');
        return '<div class="board-col"><div class="colhead"><span class="cn">'+COLS[k].title+'</span><span class="cq">'+(DATA.quarterLabel||'')+'</span></div>'+rows+'</div>';
      }).join('');
    }
    function refresh(){
      title.textContent=RNAME[cfg.room]; var seq=0, durMs=cfg.durMs;
      root.querySelectorAll('.brow').forEach(function(row){
        var t=TOWNS.filter(function(x){return x.name===row.dataset.town;})[0];
        var c=t.m[cfg.room]||[0,0],v=c[0],d=c[1],flap=row.querySelector('.flap');
        var tmp=document.createElement('div'); tmp.innerHTML=tiles(fmt(v));
        var nt=[].slice.call(tmp.children), ot=[].slice.call(flap.children);
        if(nt.length!==ot.length){ flap.innerHTML=tiles(fmt(v));
          [].forEach.call(flap.querySelectorAll('.fc:not(.sep)'),function(fc){fc.style.animationDelay=(seq++*cfg.stag)+'ms';fc.classList.add('flip');});
        } else { ot.forEach(function(o,i){var n=nt[i];
          if(o.textContent!==n.textContent||o.className!==n.className){
            if(n.classList.contains('fc')&&!n.classList.contains('sep')){
              o.classList.remove('flip'); void o.offsetWidth; var dl=seq++*cfg.stag; o.style.animationDelay=dl+'ms'; o.classList.add('flip');
              setTimeout(function(){o.textContent=n.textContent;o.className=n.className;},dl+durMs*0.5);
            } else { o.outerHTML=n.outerHTML; }
          }});
        }
        var cc=d>0?'up':(d<0?'dn':'fl'),ca=d>0?'▲':(d<0?'▼':'·'),chg=row.querySelector('.chg');
        chg.className='chg '+cc; chg.innerHTML=v?ca+' '+(d>0?'+':'')+d.toFixed(1):'&nbsp;';
      });
    }
    function setRoom(r){cfg.room=r; [].forEach.call(root.querySelectorAll('[data-flap-tabs] button'),function(b){b.classList.toggle('on',b.dataset.room===r);}); refresh();}
    [].forEach.call(root.querySelectorAll('[data-flap-tabs] button'),function(b){b.addEventListener('click',function(){cfg.auto=false; var a=root.querySelector('[data-board-auto]'); if(a)a.classList.remove('on'); stop(); setRoom(b.dataset.room);});});
    var SPEED_FACTOR={slow:1.7,normal:1,fast:0.5};
    [].forEach.call(root.querySelectorAll('[data-board-speed] button'),function(b){
      b.addEventListener('click',function(){
        cfg.speedFactor=SPEED_FACTOR[b.dataset.speed]||1;
        [].forEach.call(root.querySelectorAll('[data-board-speed] button'),function(x){x.classList.toggle('on',x===b);});
        if(cfg.auto) start();
      });
    });
    var autoBtn=root.querySelector('[data-board-auto]');
    if(autoBtn){autoBtn.addEventListener('click',function(){cfg.auto=!cfg.auto; this.classList.toggle('on',cfg.auto); cfg.auto?start():stop();}); autoBtn.classList.toggle('on',cfg.auto);}
    function cycle(){var i=ROOMS.indexOf(cfg.room); setRoom(ROOMS[(i+1)%ROOMS.length]);}
    function start(){stop(); if(cfg.auto)timer=setInterval(cycle,cfg.interval);}
    function stop(){if(timer)clearInterval(timer);}
    build(); setRoom(cfg.room); start();
  }
  function initAll(){[].forEach.call(document.querySelectorAll('[data-hdb-board]'),initBoard);}
  if(document.readyState!=='loading')initAll(); else document.addEventListener('DOMContentLoaded',initAll);
  document.addEventListener('shopify:section:load',function(e){var el=e.target.querySelector('[data-hdb-board]'); if(el){el.dataset.hdbInit=''; initBoard(el);}});
})();
